export default "__VITE_ASSET__CFktjiDH__"